import { UIHeading4, UIHeading2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IOfferHistoryProps {
  title: string;
  fullscreenViewBtn?: React.ReactElement;
  fullscreenView: React.ReactElement;
  offersTableSmall: React.ReactElement;
  tabs?: React.ReactElement;
  redesign?: boolean;
}

export const OfferHistory: React.FC<IOfferHistoryProps> = ({
  title,
  offersTableSmall,
  fullscreenViewBtn,
  fullscreenView,
  tabs,
  redesign,
}) => {
  return (
    <div className={cn(styles['container'], !redesign && styles['border'])}>
      <div className={styles['title']}>
        {redesign ? <UIHeading2>{title}</UIHeading2> : <UIHeading4>{title}</UIHeading4>}
      </div>
      {tabs}
      {offersTableSmall}
      {fullscreenViewBtn}
      {fullscreenView}
    </div>
  );
};
